/**
 * Fills `:param` placeholders in an ApiRoutes template, percent-encoding each value.
 *
 * Use this instead of react-router's `generatePath` for API URLs: file and folder
 * ids are not guaranteed to be slash-free (some upload paths mint a file_id as
 * `${folderId}/${fileName}`, e.g. "root/quote-evidence.pdf"), and generatePath
 * passes those through raw — the slash then reads as a path separator and the
 * request no longer matches the route it was built for.
 */
export const buildApiPath = (template: string, params: Record<string, string>): string =>
  Object.entries(params).reduce((path, [key, value]) => path.replace(`:${key}`, encodeURIComponent(value)), template);
